module.exports = __webpack_public_path__ + "img/ofs-i-user-shuzihua.8f810204.png";